import axiosInstance, {axiosInstanceUnAuthorized} from "../Axios/AxiosConfig";
import URLS from "../Axios/URLS";
import {is_success} from "../Axios/Status";


export default function GoogleAuthLogin(token) {
    const data = new FormData();
    data.append("token", token);

    return new Promise((resolve, reject) => {
        axiosInstanceUnAuthorized.post(URLS.GoogleAuthLoginSignUp, data).then((res) => {
            if (is_success(res?.status)) {
                resolve(res?.data);
                return;
            }
            reject(res?.data);
        }).catch((error) => {
            reject(error);
        });
    });
}

export  function GoogleAuthOneTapLogin(credential) {
    const data = new FormData();
    data.append("credential", credential);

    return new Promise((resolve, reject) => {
        axiosInstanceUnAuthorized.post(URLS.GoogleAuthOneTapLogin, data).then((res) => {
            if (is_success(res?.status)) {
                resolve(res?.data);
                return;
            }
            reject(res?.data);
        }).catch((error) => {
            reject(error);
        });
    });
}